export enum FuelType {
  Diesel = 'D',
  Electric = 'E',
}

export enum FuelTypeName {
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC',
}
